module.exports = __webpack_public_path__ + "static/media/BTS_FINALS-5.1299c3cd.jpg";